export const ADD_ARTICLE = "ADD_ARTICLE";

export const GET_USER = "GET_USER";
export const GET_USERS = "GET_USERS";

export const GET_HOUSES = "GET_HOUSES";
export const GET_CITY = "GET_CITY";

export const GET_TRANSACTIONS = "GET_TRANSACTIONS";
export const GET_HISTORY = "GET_HISTORY";
export const GET_BOOKING = "GET_BOOKING";